<template>
	<a class="publiciteAqui" href="/institucion/publicidad">
		<h1 class="animatedText">Publicite Aqui</h1>
	</a>
</template>

<style>
.publiciteAqui {
	/* aspect-ratio: 1.1006441223832528; */
	aspect-ratio: 1 / 1;

	display: flex;
	justify-content: center;
	align-items: center;

	background: #427fbb;
}

.publiciteAqui > h1 {
	color: white;
	animation: crazyAnimation 2s ease-in-out;
}

@media (orientation: portrait) {
	.publiciteAqui > h1 {
		font-size: 1.5rem;
	}
}

@keyframes crazyAnimation {
	0% {
		transform: scale(.90);
		opacity: 0;
	}
	/* 50% {
		transform: rotate(360deg);
	} */
	75% {
		transform: scale(1.10);
	}
	100% {
		transform: scale(1);
		opacity: 1;
	}
}
</style>